<template>
  
  <div id="disapprove-dialog" class="ui small modal disapprove-modal">

    <div class="ui header">
      Rejeição de Orçamento
    </div>

    <div class="content">       

      <div class="ui orange message">
        <strong><i class="exclamation circle icon"></i>Atenção</strong>
        <p>Um ou mais possuem valor aprovado. Confirma rejeição do Orçamento ?</p> 
        <p class="m-t-20">Confirma rejeição do orçamento ?</p>
      </div> 

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button type="button" class="ui basic red button" @click="onDisapprove()">
        <i class="check icon"></i>
        Rejeitar
      </button>
    </div>

  </div>

</template>

<script>

  export default {
    
    props: ["quotation"],  

    beforeDestroy() {
      $(".disapprove-modal").remove()
    },

    methods: {

      show() {       
        
        let hasAppPrice = false

        this.quotation.items.forEach((item) => {
          if (item.appPrice > 0 && !item.appAuto)
            hasAppPrice = true
        })

        if (hasAppPrice) {
          $("#disapprove-dialog").modal("show")
        } else {
          this.onDisapprove()
        }        
      },

      hide() {
        $("#disapprove-dialog").modal("hide")
      },

      onDisapprove() {
        
        this.$emit("onDisapprove")

        this.hide()
      },
    },
  }

</script>